<script>
    import {onMount} from 'svelte';

    import store from '../../Stores/tipo-de-jornada-store';

    import {url, goto} from '@sveltech/routify';

    import Loading from "../../Components/UI/Loading.svelte";
    import Error from "../../Components/UI/Error.svelte";
    import Titulo from "../../Components/UI/Titulo.svelte";
    import Migas from "../../Components/UI/Migas/Migas.svelte";
    import Miga from "../../Components/UI/Migas/Miga.svelte";
    import Formulario from "../../Components/TiposDeJornada/Edicion/Formulario.svelte";

    export let id;

    onMount(() => store.cargar(id));

    let tipoDeJornada, error, errores;
    $: tipoDeJornada = $store.tipo;
    $: error = $store.error;
</script>

<style>
    h2 .material-icons {
        font-size: 2.5em;
        vertical-align: bottom;
        line-height: 1;
    }

</style>

<svelte:head>
    <title>Edición de tipo de jornada</title>
</svelte:head>

<Migas>
    <Miga url={$url('/tipos-de-jornada')}>Tipos de jornada</Miga>
    {#if tipoDeJornada}
        <Miga actual>{tipoDeJornada.nombre}</Miga>
    {/if}
</Migas>

<Titulo>Edición de tipo de jornada</Titulo>

{#if $store.cargando}
    <Loading/>
{:else if error}
    <Error mensaje={error} on:cancel={() => error = null}/>
{:else if tipoDeJornada}
    <Formulario on:enviado={() => $goto('/tipos-de-jornada')}/>
{/if}